import useLanguage from "hooks/language";
import { XCircle } from "react-feather";
import { Button, Modal } from "../../components";
import IndexPointingUpEmoji from "../../assets/images/index-pointing-up.png";

import styles from "./ramq-required.module.css";

export default function RamqRequiredModal({
    visible,
    onEnterRamqCard,
    onSelectPrivateService,
    onClose,
}: {
    visible: boolean;
    onEnterRamqCard: () => void;
    onSelectPrivateService: () => void;
    onClose: () => void;
}): React.ReactElement {
    const { translations } = useLanguage();
    const t = translations.profileSection.ramqRequiredModal;

    return (
        <Modal
            showHeader={false}
            visible={visible}
            onVisibilityChange={(visible) => {
                if (!visible) onClose();
            }}
            className={styles["ramq-required-modal"]}
        >
            <div className={styles["ramq-required-modal__container"]}>
                <div className={styles["ramq-required-modal__close"]}>
                    <button
                        className={styles["ramq-required-modal__close-button"]}
                        aria-label={translations.common.close}
                        onClick={onClose}
                    >
                        <XCircle aria-hidden="true" focusable="false" />
                    </button>
                </div>

                <div
                    className={styles["ramq-required-modal__content-container"]}
                >
                    <img
                        src={IndexPointingUpEmoji}
                        alt="pointing finger"
                        className={styles["ramq-required-modal__icon-image"]}
                    />
                    <div
                        className={
                            styles["ramq-required-modal__attention-label"]
                        }
                    >
                        {t.attentionLabel}
                    </div>
                    <div className={styles["ramq-required-modal__title"]}>
                        {t.title}
                    </div>
                    <div className={styles["ramq-required-modal__description"]}>
                        {t.description}
                    </div>
                </div>

                <div>
                    <Button
                        type="primary"
                        className={styles["ramq-required-modal__button"]}
                        onClick={onEnterRamqCard}
                    >
                        {t.primaryAction}
                    </Button>

                    <Button
                        type="secondary"
                        className={styles["ramq-required-modal__button"]}
                        onClick={onSelectPrivateService}
                    >
                        <div>{t.secondaryAction}</div>
                        <div
                            className={
                                styles[
                                    "ramq-required-modal__button-secondaryLabel"
                                ]
                            }
                        >
                            {t.secondaryActionHelper}
                        </div>
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
